import { render } from "./TheMenuBar.vue?vue&type=template&id=2a78b706&scoped=true"
import script from "./TheMenuBar.vue?vue&type=script&lang=js"
export * from "./TheMenuBar.vue?vue&type=script&lang=js"

import "./TheMenuBar.vue?vue&type=style&index=0&id=2a78b706&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a78b706"]])

export default __exports__